// extracted by mini-css-extract-plugin
module.exports = {"bg":"e_np","border":"e_op"};